<div class="h-100 d-flex align-items-center" 
  [ngStyle]="{ 
    'background-color': params.options.layout.backgroundColor,
    'padding-top': params.options.layout.padding['top'] + 'px',
    'padding-bottom': params.options.layout.padding['bottom'] + 'px',
    'padding-left': params.options.layout.padding['left'] + 'px',
    'padding-right': params.options.layout.padding['right'] + 'px'
  }">
  <div class="h-100 w-100" #gauge></div>
</div>